import React from 'react'
import styles from '../Footer/Footer.module.css' // Import module-specific styles from Footer
import facebook from '../../Assets/Facebook.png'  // Import asset images and icons
import instagram from '../../Assets/Instagram.png'
import twitter from '../../Assets/Twitter.png'
import { Link } from 'react-router-dom'
import logo from '../../Assets/Logo-Light.png'

const Footer = () => {
    return (
        <footer className={styles.footer}>
            <div className={styles.footerBottom}>
                <div className={styles.footerMenuSection}>
                    {/* Company menu section */}
                    <div className={styles.footerMenu}>
                        <ul>
                            <li>
                                <p style={{ fontWeight: 'bold', marginBottom: -10, color: 'white' }} className="pLarge">Company</p>
                            </li>
                            <li>
                                <Link to="/about"><p>About Us</p></Link>
                            </li>
                            <li>
                                <Link to="/about"><p>Why Choose Us</p></Link>
                            </li>
                            <li>
                                <Link to="/pricing"><p>Pricing</p></Link>
                            </li>
                            <li>
                                <p>Testimonial</p>
                            </li>
                        </ul>
                    </div>

                    {/* Resources menu section */}
                    <div className={styles.footerMenu}>
                        <ul>
                            <li>
                                <p style={{ fontWeight: 'bold', color: 'white' }} className="pLarge">Resources</p>
                            </li>
                            <li>
                                <p>Privacy Policy</p>
                            </li>
                            <li>
                                <p>Terms and Conditions</p>
                            </li>
                            <li>
                                <Link to="/blog"><p>Blog</p></Link>
                            </li>
                            <li>
                                <Link to="/contact"><p>Contact Us</p></Link>
                            </li>
                        </ul>
                    </div>

                    {/* Product menu section */}
                    <div className={styles.footerMenu}>
                        <ul>
                            <li>
                                <p style={{ fontWeight: 'bold', color: 'white' }} className="pLarge">Product</p>
                            </li>
                            <li>
                                <Link to="/product"><p>Project Management</p></Link>
                            </li>
                            <li>
                                <Link to="/product"><p>Time Tracker</p></Link>
                            </li>
                            <li>
                                <Link to="/product"><p>Time Schedule</p></Link>
                            </li>
                            <li>
                                <Link to="/product"><p>Lead Generation</p></Link>
                            </li>
                            <li>
                                <Link to="/product"><p>Remote Collaboration</p></Link>
                            </li>
                        </ul>
                    </div>

                    {/* Subscription section */}
                    <div className={styles.footerSub}>
                        <Link to="/">
                            <img src={logo} alt="Finsweet Logo"></img>
                        </Link>
                        <p>Subscribe to our Newsletter</p>
                        <div className={styles.footerEmail}>
                            <input type="text" name="email" placeholder="Enter your Email" />
                            <button>Subscribe</button>
                        </div>
                    </div>
                </div>

                {/* Social media and copyright section */}
                <div className={styles.footerSocials}>
                    <div className={styles.footerLine}></div>
                    <p>© Copyright Finsweet 2022</p>
                    <img src={facebook} alt="Facebook Icon"></img>
                    <img src={twitter} alt="Twitter Icon"></img>
                    <img src={instagram} alt="Instagram Icon"></img>
                    <div style={{ marginLeft: 20 }} className={styles.footerLine}></div>
                </div>
            </div>
        </footer>
    )
}

export default Footer
